import { render } from "./NullComponent.vue?vue&type=template&id=15eb9d28&scoped=true"
import script from "./NullComponent.vue?vue&type=script&lang=js"
export * from "./NullComponent.vue?vue&type=script&lang=js"

import "./NullComponent.vue?vue&type=style&index=0&id=15eb9d28&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15eb9d28"]])

export default __exports__